import React from 'react'
import { setModal, selectModal } from '../../redux/modalSlice'
import { useDispatch, useSelector } from 'react-redux'

export default function LendoxLegendModal() {
  const dispatch = useDispatch()
  const modal = useSelector(selectModal)

  const handleClose = () => {
    dispatch(setModal({ title: ``, content: ``, type: '', is_active: false }))
  }

  return modal.is_active && modal.type === 'lendox_legend' ? (
    <div className="modal is-active is-large">
      <div className="modal-background"></div>
      <div className="modal-card column is-four-fifths">
        <header className="modal-card-head py-3">
          <p className="modal-card-title is-capitalized">{modal.title}</p>
          <button
            className="delete"
            aria-label="close"
            onClick={handleClose}
          ></button>
        </header>
        <section className="modal-card-body lox-footer-modal-card-body pt-1 pb-1 lox-legend">
          <div className="content mb-3">
            <h5 className="has-text-weight-normal is-underlined mb-1 title-customer-type">
              Customer Types
            </h5>
            <div className="columns m-0 p-0">
              <span className="column is-1 p-0 is-flex-shrink-1">NEW</span>
              <span className="column is-3 p-0">New First-time Customer</span>
            </div>
            <div className="columns m-0 p-0">
              <span className="column is-1 p-0 is-flex-shrink-1">REACT</span>
              <span className="column is-3 p-0">Returning Customer</span>
            </div>
          </div>
          <div className="content">
            <h5 className="has-text-weight-normal is-underlined mb-1">
              Date Format
            </h5>
            <span>YYMMDD HH:MM:SS</span>
          </div>
        </section>
        <footer className="modal-card-foot is-justify-content-end py-1">
          <div className="lox-form__buttons-wrapper has-text-right">
            <button
              type="button"
              onClick={handleClose}
              className="button is-small has-background-grey has-text-white"
            >
              Close
            </button>
          </div>
        </footer>
      </div>
    </div>
  ) : (
    ''
  )
}
